"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SPACE = exports.LINE_HEIGHTS = exports.FONT_SIZE = void 0;

/*
 * Icon sizes
 */
// Alias, can act as Interface
// Type

/*
 * Font sizes
 */
// Constants
var FONT_SIZE = {
  XXXSMALL: 'xxxsmall',
  XXSMALL: 'xxsmall',
  XSMALL: 'xsmall',
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  XLARGE: 'xlarge',
  XXLARGE: 'xxlarge',
  XXXLARGE: 'xxxlarge',
  XXXXLARGE: 'xxxxlarge'
}; // Alias, can act as Interface

exports.FONT_SIZE = FONT_SIZE;

/*
 * Line height sizes
 */
// Constants
var LINE_HEIGHTS = {
  XXXSMALL: 'xxxsmall',
  XXSMALL: 'xxsmall',
  XSMALL: 'xsmall',
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  XLARGE: 'xlarge',
  XXLARGE: 'xxlarge',
  XXXLARGE: 'xxxlarge'
}; // Type

exports.LINE_HEIGHTS = LINE_HEIGHTS;
// Constants
var SPACE = {
  NONE: 'none',
  XSMALL: 'xsmall',
  SMALL: 'small',
  SMEDIUM: 'smedium',
  MEDIUM: 'medium',
  LARGE: 'large',
  XLARGE: 'xlarge',
  XXLARGE: 'xxlarge',
  XXXLARGE: 'xxxlarge'
}; // Type

exports.SPACE = SPACE;